(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './korge-root-kds.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-uuid-kotlinx-uuid-core.js', './korge-root-korgw.js', './korge-root-klock.js', './88b0986a7186d029-atomicfu-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./korge-root-kds.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-uuid-kotlinx-uuid-core.js'), require('./korge-root-korgw.js'), require('./korge-root-klock.js'), require('./88b0986a7186d029-atomicfu-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['korge-root-kds'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'korge-root-kds' was not found. Please, check whether 'korge-root-kds' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['kotlinx-uuid-kotlinx-uuid-core'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'kotlinx-uuid-kotlinx-uuid-core' was not found. Please, check whether 'kotlinx-uuid-kotlinx-uuid-core' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['korge-root-korgw'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'korge-root-korgw' was not found. Please, check whether 'korge-root-korgw' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['korge-root-klock'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency 'korge-root-klock' was not found. Please, check whether 'korge-root-klock' is loaded prior to 'metron-shared'.");
    }
    if (typeof this['88b0986a7186d029-atomicfu-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-shared'. Its dependency '88b0986a7186d029-atomicfu-js-ir' was not found. Please, check whether '88b0986a7186d029-atomicfu-js-ir' is loaded prior to 'metron-shared'.");
    }
    root['metron-shared'] = factory(typeof this['metron-shared'] === 'undefined' ? {} : this['metron-shared'], this['kotlin-kotlin-stdlib-js-ir'], this['korge-root-kds'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-uuid-kotlinx-uuid-core'], this['korge-root-korgw'], this['korge-root-klock'], this['88b0986a7186d029-atomicfu-js-ir']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korlibs_kds_kds, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_app_softwork_kotlinx_uuid_core, kotlin_com_soywiz_korlibs_korgw_korgw, kotlin_com_soywiz_korlibs_klock_klock, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_getInstance = kotlin_kotlin.$_$.a5;
  var intMapOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.m2;
  var ensureNotNull = kotlin_kotlin.$_$.th;
  var Enum = kotlin_kotlin.$_$.qg;
  var protoOf = kotlin_kotlin.$_$.yc;
  var classMeta = kotlin_kotlin.$_$.lb;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var listOf = kotlin_kotlin.$_$.k8;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var equals = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.xb;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.ph;
  var createKType = kotlin_kotlin.$_$.b;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var Default_getInstance = kotlin_app_softwork_kotlinx_uuid_core.$_$.a;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var Event = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b4;
  var objectCreate = kotlin_kotlin.$_$.wc;
  var getStringHashCode = kotlin_kotlin.$_$.wb;
  var Companion_getInstance = kotlin_com_soywiz_korlibs_klock_klock.$_$.a1;
  var _DateTime___get_unixMillisLong__impl__sdx9bd = kotlin_com_soywiz_korlibs_klock_klock.$_$.e;
  var Long = kotlin_kotlin.$_$.ug;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var toString = kotlin_kotlin.$_$.dd;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.c;
  //endregion
  //region block: pre-declaration
  setMetadataFor(State, 'State', classMeta, Enum);
  setMetadataFor(Registry, 'Registry', objectMeta);
  setMetadataFor(PacketImp, 'PacketImp', classMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LoginSuccess, 'LoginSuccess', classMeta, Event, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LoginStart, 'LoginStart', classMeta, Event, VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RedirectRequest, 'RedirectRequest', classMeta, Event, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PingResponse, 'PingResponse', classMeta, Event, VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(GameJoinPacket, 'GameJoinPacket', classMeta, Event, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PingRequest, 'PingRequest', classMeta, Event, VOID, VOID, {0: $serializer_getInstance_4});
  //endregion
  var State_LOGIN_instance;
  var State_PLAY_instance;
  var State_CLOSED_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_getInstance();
    State_entriesInitialized = true;
    State_LOGIN_instance = new State('LOGIN', 0);
    State_PLAY_instance = new State('PLAY', 1);
    State_CLOSED_instance = new State('CLOSED', 2);
  }
  function toPacketMap(_this__u8e3s4, $this) {
    // Inline function 'kotlin.also' call
    var tmp0_also = intMapOf([]);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'Registry.toPacketMap.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < _this__u8e3s4.j()) {
      // Inline function 'Registry.toPacketMap.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0_anonymous = _this__u8e3s4.k(tmp0);
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var tmp0_getOrPut = tmp0_anonymous.hl().t5_1;
      var res = tmp0_also.k(tmp0_getOrPut);
      if (res == null) {
        var tmp$ret$0;
        // Inline function 'Registry.toPacketMap.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$0 = intMapOf([]);
        tmp0_also.h1b(tmp0_getOrPut, tmp$ret$0);
      }
      ensureNotNull(tmp0_also.k(tmp0_getOrPut)).h1b(tmp0_anonymous.weq(), tmp0_anonymous);
    }
    return tmp0_also;
  }
  function State(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Registry() {
    Registry_instance = this;
    this.xeq_1 = toPacketMap(listOf([Companion_getInstance_3(), Companion_getInstance_4(), Companion_getInstance_0(), Companion_getInstance_2()]), this);
    this.yeq_1 = toPacketMap(listOf([Companion_getInstance_1(), Companion_getInstance_5()]), this);
  }
  var Registry_instance;
  function Registry_getInstance() {
    if (Registry_instance == null)
      new Registry();
    return Registry_instance;
  }
  function State_LOGIN_getInstance() {
    State_initEntries();
    return State_LOGIN_instance;
  }
  function State_PLAY_getInstance() {
    State_initEntries();
    return State_PLAY_instance;
  }
  function PacketImp(id, state, kType) {
    this.zeq_1 = id;
    this.aer_1 = state;
    this.ber_1 = kType;
  }
  protoOf(PacketImp).weq = function () {
    return this.zeq_1;
  };
  protoOf(PacketImp).hl = function () {
    return this.aer_1;
  };
  protoOf(PacketImp).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PacketImp))
      return false;
    var tmp0_other_with_cast = other instanceof PacketImp ? other : THROW_CCE();
    if (!(this.zeq_1 === tmp0_other_with_cast.zeq_1))
      return false;
    if (!this.aer_1.equals(tmp0_other_with_cast.aer_1))
      return false;
    if (!equals(this.ber_1, tmp0_other_with_cast.ber_1))
      return false;
    return true;
  };
  protoOf(PacketImp).hashCode = function () {
    var result = this.zeq_1;
    result = imul(result, 31) + this.aer_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ber_1) | 0;
    return result;
  };
  protoOf(PacketImp).toString = function () {
    return 'PacketImp(id=' + this.zeq_1 + ', state=' + this.aer_1 + ', kType=' + this.ber_1 + ')';
  };
  function get_clientIdCounter() {
    _init_properties_Packets_kt__u2q8jr();
    return clientIdCounter;
  }
  var clientIdCounter;
  function get_serverIdCounter() {
    _init_properties_Packets_kt__u2q8jr();
    return serverIdCounter;
  }
  var serverIdCounter;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'Login' call
    var tmp0_Login = generateClientID();
    // Inline function 'packet' call
    var tmp0_packet = State_LOGIN_getInstance();
    tmp.cer_1 = new PacketImp(tmp0_Login, tmp0_packet, createKType(getKClass(LoginSuccess), arrayOf([]), false));
  }
  protoOf(Companion).weq = function () {
    return this.cer_1.zeq_1;
  };
  protoOf(Companion).hl = function () {
    return this.cer_1.aer_1;
  };
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LoginSuccess', this, 3);
    tmp0_serialDesc.aei('username', false);
    tmp0_serialDesc.aei('userUuid', false);
    tmp0_serialDesc.aei('loginToken', false);
    this.der_1 = tmp0_serialDesc;
  }
  protoOf($serializer).eer = function (encoder, value) {
    var tmp0_desc = this.der_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    tmp1_output.tec(tmp0_desc, 0, value.ier_1);
    tmp1_output.vec(tmp0_desc, 1, Default_getInstance(), value.jer_1);
    tmp1_output.vec(tmp0_desc, 2, Default_getInstance(), value.ker_1);
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer).le8 = function (encoder, value) {
    return this.eer(encoder, value instanceof LoginSuccess ? value : THROW_CCE());
  };
  protoOf($serializer).me8 = function (decoder) {
    var tmp0_desc = this.der_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.geb(tmp0_desc);
    if (tmp7_input.veb()) {
      tmp4_local0 = tmp7_input.qeb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.seb(tmp0_desc, 1, Default_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.seb(tmp0_desc, 2, Default_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.qeb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.seb(tmp0_desc, 1, Default_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.seb(tmp0_desc, 2, Default_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.heb(tmp0_desc);
    return LoginSuccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).ke8 = function () {
    return this.der_1;
  };
  protoOf($serializer).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), Default_getInstance(), Default_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function LoginSuccess_init_$Init$(seen0, username, userUuid, loginToken, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance().der_1);
    }
    Event.call($this);
    $this.ier_1 = username;
    $this.jer_1 = userUuid;
    $this.ker_1 = loginToken;
    $this.her_1 = Companion_getInstance_0();
    return $this;
  }
  function LoginSuccess_init_$Create$(seen0, username, userUuid, loginToken, serializationConstructorMarker) {
    return LoginSuccess_init_$Init$(seen0, username, userUuid, loginToken, serializationConstructorMarker, objectCreate(protoOf(LoginSuccess)));
  }
  function LoginSuccess(username, userUuid, loginToken) {
    Companion_getInstance_0();
    Event.call(this);
    this.her_1 = Companion_getInstance_0();
    this.ier_1 = username;
    this.jer_1 = userUuid;
    this.ker_1 = loginToken;
  }
  protoOf(LoginSuccess).weq = function () {
    return this.her_1.weq();
  };
  protoOf(LoginSuccess).hl = function () {
    return this.her_1.hl();
  };
  protoOf(LoginSuccess).r6p = function () {
    return Companion_getInstance_0();
  };
  protoOf(LoginSuccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginSuccess))
      return false;
    var tmp0_other_with_cast = other instanceof LoginSuccess ? other : THROW_CCE();
    if (!(this.ier_1 === tmp0_other_with_cast.ier_1))
      return false;
    if (!this.jer_1.equals(tmp0_other_with_cast.jer_1))
      return false;
    if (!this.ker_1.equals(tmp0_other_with_cast.ker_1))
      return false;
    return true;
  };
  protoOf(LoginSuccess).hashCode = function () {
    var result = getStringHashCode(this.ier_1);
    result = imul(result, 31) + this.jer_1.hashCode() | 0;
    result = imul(result, 31) + this.ker_1.hashCode() | 0;
    return result;
  };
  protoOf(LoginSuccess).toString = function () {
    return 'LoginSuccess(username=' + this.ier_1 + ', userUuid=' + this.jer_1 + ', loginToken=' + this.ker_1 + ')';
  };
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'Login' call
    var tmp0_Login = generateServerID();
    // Inline function 'packet' call
    var tmp0_packet = State_LOGIN_getInstance();
    tmp.ler_1 = new PacketImp(tmp0_Login, tmp0_packet, createKType(getKClass(LoginStart), arrayOf([]), false));
  }
  protoOf(Companion_0).weq = function () {
    return this.ler_1.zeq_1;
  };
  protoOf(Companion_0).hl = function () {
    return this.ler_1.aer_1;
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LoginStart', this, 5);
    tmp0_serialDesc.aei('name', false);
    tmp0_serialDesc.aei('version', false);
    tmp0_serialDesc.aei('loginToken', false);
    tmp0_serialDesc.aei('currentUrl', false);
    tmp0_serialDesc.aei('clientWebsite', false);
    this.mer_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ner = function (encoder, value) {
    var tmp0_desc = this.mer_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    tmp1_output.tec(tmp0_desc, 0, value.rer_1);
    tmp1_output.tec(tmp0_desc, 1, value.ser_1);
    tmp1_output.vec(tmp0_desc, 2, Default_getInstance(), value.ter_1);
    tmp1_output.tec(tmp0_desc, 3, value.uer_1);
    tmp1_output.tec(tmp0_desc, 4, value.ver_1);
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer_0).le8 = function (encoder, value) {
    return this.ner(encoder, value instanceof LoginStart ? value : THROW_CCE());
  };
  protoOf($serializer_0).me8 = function (decoder) {
    var tmp0_desc = this.mer_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.geb(tmp0_desc);
    if (tmp9_input.veb()) {
      tmp4_local0 = tmp9_input.qeb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.qeb(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.seb(tmp0_desc, 2, Default_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.qeb(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.qeb(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.qeb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.qeb(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.seb(tmp0_desc, 2, Default_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.qeb(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.qeb(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.heb(tmp0_desc);
    return LoginStart_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_0).ke8 = function () {
    return this.mer_1;
  };
  protoOf($serializer_0).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), Default_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function LoginStart_init_$Init$(seen0, name, version, loginToken, currentUrl, clientWebsite, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_0().mer_1);
    }
    Event.call($this);
    $this.rer_1 = name;
    $this.ser_1 = version;
    $this.ter_1 = loginToken;
    $this.uer_1 = currentUrl;
    $this.ver_1 = clientWebsite;
    $this.qer_1 = Companion_getInstance_1();
    return $this;
  }
  function LoginStart_init_$Create$(seen0, name, version, loginToken, currentUrl, clientWebsite, serializationConstructorMarker) {
    return LoginStart_init_$Init$(seen0, name, version, loginToken, currentUrl, clientWebsite, serializationConstructorMarker, objectCreate(protoOf(LoginStart)));
  }
  function LoginStart(name, version, loginToken, currentUrl, clientWebsite) {
    Companion_getInstance_1();
    Event.call(this);
    this.qer_1 = Companion_getInstance_1();
    this.rer_1 = name;
    this.ser_1 = version;
    this.ter_1 = loginToken;
    this.uer_1 = currentUrl;
    this.ver_1 = clientWebsite;
  }
  protoOf(LoginStart).weq = function () {
    return this.qer_1.weq();
  };
  protoOf(LoginStart).hl = function () {
    return this.qer_1.hl();
  };
  protoOf(LoginStart).r6p = function () {
    return Companion_getInstance_1();
  };
  protoOf(LoginStart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginStart))
      return false;
    var tmp0_other_with_cast = other instanceof LoginStart ? other : THROW_CCE();
    if (!(this.rer_1 === tmp0_other_with_cast.rer_1))
      return false;
    if (!(this.ser_1 === tmp0_other_with_cast.ser_1))
      return false;
    if (!this.ter_1.equals(tmp0_other_with_cast.ter_1))
      return false;
    if (!(this.uer_1 === tmp0_other_with_cast.uer_1))
      return false;
    if (!(this.ver_1 === tmp0_other_with_cast.ver_1))
      return false;
    return true;
  };
  protoOf(LoginStart).hashCode = function () {
    var result = getStringHashCode(this.rer_1);
    result = imul(result, 31) + getStringHashCode(this.ser_1) | 0;
    result = imul(result, 31) + this.ter_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.uer_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ver_1) | 0;
    return result;
  };
  protoOf(LoginStart).toString = function () {
    return 'LoginStart(name=' + this.rer_1 + ', version=' + this.ser_1 + ', loginToken=' + this.ter_1 + ', currentUrl=' + this.uer_1 + ', clientWebsite=' + this.ver_1 + ')';
  };
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'Login' call
    var tmp0_Login = generateClientID();
    // Inline function 'packet' call
    var tmp0_packet = State_LOGIN_getInstance();
    tmp.wer_1 = new PacketImp(tmp0_Login, tmp0_packet, createKType(getKClass(RedirectRequest), arrayOf([]), false));
  }
  protoOf(Companion_1).weq = function () {
    return this.wer_1.zeq_1;
  };
  protoOf(Companion_1).hl = function () {
    return this.wer_1.aer_1;
  };
  var Companion_instance_1;
  function Companion_getInstance_2() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    this.xer_1 = new PluginGeneratedSerialDescriptor('RedirectRequest', this, 0);
  }
  protoOf($serializer_1).yer = function (encoder, value) {
    var tmp0_desc = this.xer_1;
    encoder.geb(tmp0_desc).heb(tmp0_desc);
  };
  protoOf($serializer_1).le8 = function (encoder, value) {
    return this.yer(encoder, value instanceof RedirectRequest ? value : THROW_CCE());
  };
  protoOf($serializer_1).me8 = function (decoder) {
    var tmp0_desc = this.xer_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp4_input = decoder.geb(tmp0_desc);
    if (!tmp4_input.veb())
      while (tmp1_flag) {
        tmp2_index = tmp4_input.web(tmp0_desc);
        if (tmp2_index === -1)
          tmp1_flag = false;
        else
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    tmp4_input.heb(tmp0_desc);
    return RedirectRequest_init_$Create$(0, null);
  };
  protoOf($serializer_1).ke8 = function () {
    return this.xer_1;
  };
  protoOf($serializer_1).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RedirectRequest_init_$Init$(seen0, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_1().xer_1);
    }
    Event.call($this);
    $this.bes_1 = Companion_getInstance_2();
    return $this;
  }
  function RedirectRequest_init_$Create$(seen0, serializationConstructorMarker) {
    return RedirectRequest_init_$Init$(seen0, serializationConstructorMarker, objectCreate(protoOf(RedirectRequest)));
  }
  function RedirectRequest() {
    Companion_getInstance_2();
    Event.call(this);
    this.bes_1 = Companion_getInstance_2();
  }
  protoOf(RedirectRequest).weq = function () {
    return this.bes_1.weq();
  };
  protoOf(RedirectRequest).hl = function () {
    return this.bes_1.hl();
  };
  protoOf(RedirectRequest).r6p = function () {
    return Companion_getInstance_2();
  };
  function generateClientID() {
    _init_properties_Packets_kt__u2q8jr();
    return get_clientIdCounter().atomicfu$getAndAdd(1);
  }
  function generateServerID() {
    _init_properties_Packets_kt__u2q8jr();
    return get_serverIdCounter().atomicfu$getAndAdd(1);
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'Play' call
    var tmp0_Play = generateClientID();
    // Inline function 'packet' call
    var tmp0_packet = State_PLAY_getInstance();
    tmp.ces_1 = new PacketImp(tmp0_Play, tmp0_packet, createKType(getKClass(PingResponse), arrayOf([]), false));
  }
  protoOf(Companion_2).weq = function () {
    return this.ces_1.zeq_1;
  };
  protoOf(Companion_2).hl = function () {
    return this.ces_1.aer_1;
  };
  var Companion_instance_2;
  function Companion_getInstance_3() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PingResponse', this, 1);
    tmp0_serialDesc.aei('time', true);
    this.des_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ees = function (encoder, value) {
    var tmp0_desc = this.des_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    if (tmp1_output.zec(tmp0_desc, 0) ? true : !value.ies_1.equals(_DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance().yy()))) {
      tmp1_output.pec(tmp0_desc, 0, value.ies_1);
    }
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer_2).le8 = function (encoder, value) {
    return this.ees(encoder, value instanceof PingResponse ? value : THROW_CCE());
  };
  protoOf($serializer_2).me8 = function (decoder) {
    var tmp0_desc = this.des_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.geb(tmp0_desc);
    if (tmp5_input.veb()) {
      tmp4_local0 = tmp5_input.meb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.meb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.heb(tmp0_desc);
    return PingResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).ke8 = function () {
    return this.des_1;
  };
  protoOf($serializer_2).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function PingResponse_init_$Init$(seen0, time, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().des_1);
    }
    Event.call($this);
    if (0 === (seen0 & 1))
      $this.ies_1 = _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance().yy());
    else
      $this.ies_1 = time;
    $this.hes_1 = Companion_getInstance_3();
    return $this;
  }
  function PingResponse_init_$Create$(seen0, time, serializationConstructorMarker) {
    return PingResponse_init_$Init$(seen0, time, serializationConstructorMarker, objectCreate(protoOf(PingResponse)));
  }
  function PingResponse(time) {
    Companion_getInstance_3();
    time = time === VOID ? _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance().yy()) : time;
    Event.call(this);
    this.hes_1 = Companion_getInstance_3();
    this.ies_1 = time;
  }
  protoOf(PingResponse).weq = function () {
    return this.hes_1.weq();
  };
  protoOf(PingResponse).hl = function () {
    return this.hes_1.hl();
  };
  protoOf(PingResponse).r6p = function () {
    return Companion_getInstance_3();
  };
  protoOf(PingResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PingResponse))
      return false;
    var tmp0_other_with_cast = other instanceof PingResponse ? other : THROW_CCE();
    if (!this.ies_1.equals(tmp0_other_with_cast.ies_1))
      return false;
    return true;
  };
  protoOf(PingResponse).hashCode = function () {
    return this.ies_1.hashCode();
  };
  protoOf(PingResponse).toString = function () {
    return 'PingResponse(time=' + toString(this.ies_1) + ')';
  };
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'Play' call
    var tmp0_Play = generateClientID();
    // Inline function 'packet' call
    var tmp0_packet = State_PLAY_getInstance();
    tmp.jes_1 = new PacketImp(tmp0_Play, tmp0_packet, createKType(getKClass(GameJoinPacket), arrayOf([]), false));
  }
  protoOf(Companion_3).weq = function () {
    return this.jes_1.zeq_1;
  };
  protoOf(Companion_3).hl = function () {
    return this.jes_1.aer_1;
  };
  var Companion_instance_3;
  function Companion_getInstance_4() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameJoinPacket', this, 1);
    tmp0_serialDesc.aei('name', false);
    this.kes_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).les = function (encoder, value) {
    var tmp0_desc = this.kes_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    tmp1_output.tec(tmp0_desc, 0, value.pes_1);
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer_3).le8 = function (encoder, value) {
    return this.les(encoder, value instanceof GameJoinPacket ? value : THROW_CCE());
  };
  protoOf($serializer_3).me8 = function (decoder) {
    var tmp0_desc = this.kes_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.geb(tmp0_desc);
    if (tmp5_input.veb()) {
      tmp4_local0 = tmp5_input.qeb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.qeb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.heb(tmp0_desc);
    return GameJoinPacket_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_3).ke8 = function () {
    return this.kes_1;
  };
  protoOf($serializer_3).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function GameJoinPacket_init_$Init$(seen0, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().kes_1);
    }
    Event.call($this);
    $this.pes_1 = name;
    $this.oes_1 = Companion_getInstance_4();
    return $this;
  }
  function GameJoinPacket_init_$Create$(seen0, name, serializationConstructorMarker) {
    return GameJoinPacket_init_$Init$(seen0, name, serializationConstructorMarker, objectCreate(protoOf(GameJoinPacket)));
  }
  function GameJoinPacket(name) {
    Companion_getInstance_4();
    Event.call(this);
    this.oes_1 = Companion_getInstance_4();
    this.pes_1 = name;
  }
  protoOf(GameJoinPacket).weq = function () {
    return this.oes_1.weq();
  };
  protoOf(GameJoinPacket).hl = function () {
    return this.oes_1.hl();
  };
  protoOf(GameJoinPacket).r6p = function () {
    return Companion_getInstance_4();
  };
  protoOf(GameJoinPacket).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GameJoinPacket))
      return false;
    var tmp0_other_with_cast = other instanceof GameJoinPacket ? other : THROW_CCE();
    if (!(this.pes_1 === tmp0_other_with_cast.pes_1))
      return false;
    return true;
  };
  protoOf(GameJoinPacket).hashCode = function () {
    return getStringHashCode(this.pes_1);
  };
  protoOf(GameJoinPacket).toString = function () {
    return 'GameJoinPacket(name=' + this.pes_1 + ')';
  };
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'Play' call
    var tmp0_Play = generateServerID();
    // Inline function 'packet' call
    var tmp0_packet = State_PLAY_getInstance();
    tmp.qes_1 = new PacketImp(tmp0_Play, tmp0_packet, createKType(getKClass(PingRequest), arrayOf([]), false));
  }
  protoOf(Companion_4).weq = function () {
    return this.qes_1.zeq_1;
  };
  protoOf(Companion_4).hl = function () {
    return this.qes_1.aer_1;
  };
  var Companion_instance_4;
  function Companion_getInstance_5() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PingRequest', this, 1);
    tmp0_serialDesc.aei('time', true);
    this.res_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ses = function (encoder, value) {
    var tmp0_desc = this.res_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    tmp1_output.pec(tmp0_desc, 0, value.wes_1);
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer_4).le8 = function (encoder, value) {
    return this.ses(encoder, value instanceof PingRequest ? value : THROW_CCE());
  };
  protoOf($serializer_4).me8 = function (decoder) {
    var tmp0_desc = this.res_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.geb(tmp0_desc);
    if (tmp5_input.veb()) {
      tmp4_local0 = tmp5_input.meb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.meb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.heb(tmp0_desc);
    return PingRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).ke8 = function () {
    return this.res_1;
  };
  protoOf($serializer_4).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function PingRequest_init_$Init$(seen0, time, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_4().res_1);
    }
    Event.call($this);
    if (0 === (seen0 & 1))
      $this.wes_1 = _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance().yy());
    else
      $this.wes_1 = time;
    $this.ves_1 = Companion_getInstance_5();
    return $this;
  }
  function PingRequest_init_$Create$(seen0, time, serializationConstructorMarker) {
    return PingRequest_init_$Init$(seen0, time, serializationConstructorMarker, objectCreate(protoOf(PingRequest)));
  }
  function PingRequest(time) {
    Companion_getInstance_5();
    time = time === VOID ? _DateTime___get_unixMillisLong__impl__sdx9bd(Companion_getInstance().yy()) : time;
    Event.call(this);
    this.ves_1 = Companion_getInstance_5();
    this.wes_1 = time;
  }
  protoOf(PingRequest).weq = function () {
    return this.ves_1.weq();
  };
  protoOf(PingRequest).hl = function () {
    return this.ves_1.hl();
  };
  protoOf(PingRequest).r6p = function () {
    return Companion_getInstance_5();
  };
  protoOf(PingRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PingRequest))
      return false;
    var tmp0_other_with_cast = other instanceof PingRequest ? other : THROW_CCE();
    if (!this.wes_1.equals(tmp0_other_with_cast.wes_1))
      return false;
    return true;
  };
  protoOf(PingRequest).hashCode = function () {
    return this.wes_1.hashCode();
  };
  protoOf(PingRequest).toString = function () {
    return 'PingRequest(time=' + toString(this.wes_1) + ')';
  };
  var properties_initialized_Packets_kt_d9tjcr;
  function _init_properties_Packets_kt__u2q8jr() {
    if (!properties_initialized_Packets_kt_d9tjcr) {
      properties_initialized_Packets_kt_d9tjcr = true;
      clientIdCounter = atomic$int$1(0);
      serverIdCounter = atomic$int$1(0);
    }
  }
  //region block: post-declaration
  protoOf($serializer).dei = typeParametersSerializers;
  protoOf($serializer_0).dei = typeParametersSerializers;
  protoOf($serializer_1).dei = typeParametersSerializers;
  protoOf($serializer_2).dei = typeParametersSerializers;
  protoOf($serializer_3).dei = typeParametersSerializers;
  protoOf($serializer_4).dei = typeParametersSerializers;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Registry_getInstance;
  //endregion
  return _;
}));
